module.exports = __webpack_public_path__ + "img/openManagement.013bb1cc.svg";